export var environment: any = {
    production: false,
    debug: false,
    beHost: 'https://streaming.digitalmens.dev',
    websocketHost: 'streaming.digitalmens.dev',
    websocketUrl: 'wss://streaming.digitalmens.dev',
    // websocketUrl:'wss://web-rtc-be-l6vw.onrender.com',
    isStatsEnabled: false,
    rtcConfig:{
        // iceTransportPolicy : "relay",
        sdpSemantics: "unified-plan",
        iceServers: [
            // {
            //     urls: 'turn:turn.solveup.it:3478',
            //     username: 'turnros',
            //     credential: 'RosTurn2020'
            // },
            {
                urls: 'turn:turn.digitalemens.dev:3478',
                username: 'turn_digital',
                credential: 'Digital_2024!'
            },
            {
                urls: 'stun:stun.l.google.com:19302'
            }
        ]
    },
    googleApiKey: 'AIzaSyA3vPM8J5lf1EcEZqRyM6GX-1xE8hcIaIc',
    isTranslateEnabled: true,
    saveScreenshotOnServer: true,
    saveLocallyScreenshot: false,
    isRecordingVisible: true
}